<template>
    <div class="product-edit-attachments p-2" v-loading="loader">

        <h5 class="mt-5">Rechercher des fichiers à ajouter</h5>
        <div class="row">
            <div class="col-lg-4">
                <el-input @keyup.enter.native="search" placeholder="Fichier" v-model="q"></el-input>
            </div>
            <div class="col-lg-3">
                <el-select v-model="category" placeholder="Catégorie">
                    <el-option v-for="item in categoryOptions" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <div class="col-lg-5">
                <el-button type="primary" @click.prevent="search" plain>Rechercher</el-button>
                <el-button type="default" @click.prevent="reset" plain>Reset</el-button>
            </div>         
        </div>
        <div v-if="notFound" class="alert alert-warning mt-5">
            <p>Pas de fichier trouver</p>
        </div>
        <el-table v-if="finded.length" v-loading="loading" style="width: 100%" :data="finded" stripe>
            <el-table-column prop="name" label="Nom" sortable="custom"></el-table-column>
            <el-table-column prop="filename" label="Fichier" sortable="custom"></el-table-column>
            <el-table-column prop="category" label="Categorie" sortable="custom">
                <template slot-scope="scope">
                    <span>
                        {{ getCategoryName(scope.row.category) }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column prop="shop_id" label="ID Speedway" sortable="custom"></el-table-column>
            <el-table-column label="Actions" fixed="right">
                <template slot-scope="scope">
                    <el-button v-if="!inList(scope.row.id)" @click="addFile(scope.row)" type="success" icon="el-icon-plus" size="mini"></el-button>
                </template>
            </el-table-column>
        </el-table>  
        <hr>

        <h5 class="mt-5">Liste des fichiers</h5>

        <el-table style="width: 100%" ref="multipleTable" :data="product.files" stripe >
            <el-table-column prop="name" label="Nom" sortable="custom"></el-table-column>
            <el-table-column prop="filename" label="Fichier" sortable="custom"></el-table-column>
            <el-table-column prop="category" label="Categorie" sortable="custom">
                <template slot-scope="scope">
                    <span>
                        {{ getCategoryName(scope.row.category) }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column prop="shop_id" label="ID Speedway" sortable="custom"></el-table-column>
            <el-table-column label="Actions" fixed="right">
                <template slot-scope="scope">
                    <a href="#" class="text-danger" @click.prevent="removeFile(scope.row)" >
                        <i class="fe fe-trash"></i>
                    </a>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
import categoryOptions from '../File/categoryOptions'
export default {
data() {
        return {
            loader: false,
            loading: false,
            categoryOptions: categoryOptions,
            q: null,
            category: null,
            finded: [],
            notFound: false
        }
    },
    props: {
        product: {
            required: true
        }
    },
    computed: {
        productId() {
            return this.product.id;
        },
    },
    created() {
    },
    methods: {
        search()
        {
            this.notFound = false;
            var excluded = this.product.files.map(v => v.id);
            var excludedString = excluded.join(',')
            var params = {
                exclude_files: excludedString,
                q: this.q,
                category: this.category,
                mode: 'search'
            }
            this.loading = true
            axios.get('/files', {params}).then(r => {
                this.finded = r.data.data
                if(!this.finded.length) {
                    this.notFound = true;
                }
            }).catch(r=>{

            }).then(()=>{
                this.loading = false
            })
        },
        reset()
        {
            this.q = null;
            this.finded = [];
        },
        getCategoryName(cat) 
        {
            let finded = categoryOptions.find( v => v.value == cat );
            return finded.label;
        },
        inList(id)
        {
            return this.product.files.filter(v=>v.id == id).length
        },
        removeFile(file)
        {
            this.$confirm('Etes-vous sûr ?', 'Attention', {
                confirmButtonText: 'Oui',
                cancelButtonText: 'Annuler',
                type: 'warning'
            }).then(() => {
                this.loader = true;
                var datas = {
                    mode: 'disociateFile',
                    file_id: file.id
                };
                axios
                    .post('/products/'+this.product.id, datas)
                    .then(r => {
                        this.$store.dispatch('products/updateInList', {id: this.product.id, data:r.data.data})
                        this.product =  this.product.update(r.data.data);
                        this.goToPage(1)
                    })
                    .catch(() => {})
                    .then(() => {
                        this.loader = false;
                    });

            }).catch(()=>{})
        },
        addFile(file)
        {
            this.loader = true;
            var datas = {
                mode: 'associateFile',
                file_id: file.id
            };
            axios
                .post('/products/'+this.product.id, datas)
                .then(r => {
                    this.$store.dispatch('products/updateInList', {id: this.product.id, data:r.data.data})
                    this.product =  this.product.update(r.data.data);
                    this.goToPage(1)
                })
                .catch(() => {})
                .then(() => {
                    this.loader = false;
                });

        }
    }
}
</script>

<style lang="scss">
    .product-edit-features {
        .el-select {
            width: 100%;
        }
    }
</style>